import { gql } from '@parkchirp/api-client';

export const GET_TENANTS_PER_SUBSCRIPTION = gql`
    query GetTenantsPerSubscription(
        $subscriptionId: String!
        $tenantSubscriptionId: String
    ) {
        getTenantsPerSubscription(
            subscriptionId: $subscriptionId
            tenantSubscriptionId: $tenantSubscriptionId
        ) {
            id
            isPayor
            subscriptionId
            userEmail
        }
    }
`;
